import { render } from "./appsListAdmin.vue?vue&type=template&id=429d704a&scoped=true"
import script from "./appsListAdmin.vue?vue&type=script&lang=js"
export * from "./appsListAdmin.vue?vue&type=script&lang=js"

import "./appsListAdmin.vue?vue&type=style&index=0&id=429d704a&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429d704a"]])

export default __exports__